import React from 'react'
import { withRouter } from "react-router-dom";
import { Dialog, DialogContentText, DialogTitle, DialogActions, DialogContent, Button, Slide, Snackbar, TextField, Icon } from '@material-ui/core';
import Http from '../../../Http';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import GuiaLog from './GuiaLog';
import GuiaComment from './GuiaComment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ACCESS from '../../../ACCESS';

class Guias extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'guia/filter', deleteUrl: 'guia/delete', deleteField: 'guia_folio', modUrl: '/Guias/Guia', key: 'id' },
      TableOp.Table(false, [
        { label: 'Guia', id: 'guia_folio' },
        { label: 'Estado', id: 'estado' },
        { label: 'Fecha Creada', id: 'createdAt' },
        { label: 'Origen', id: 'origen' },
        { label: 'Destino', id: 'destino' },
        { label: 'Cliente', id: 'cliente' },
        { label: 'Embarque', id: 'embarque' },
        { label: 'No. Pedimento', id: 'g_pedimento' },
        { label: 'Pedido/Remision/Manifiesto', id: 'g_pedido_remision_manifiesto' },
        { label: 'Folio Entrega', id: 'entrega' },
        { label: 'Guia Previa', id: 'guia_previa' },
        { label: 'Condicion', id: 'condicion_nombre' },
        { label: 'Enviado CYC', id: 'enviado_cyc' },
        { label: 'Recibido CYC', id: 'recibido_cyc' },
        { label: 'Tipo entrega', id: 'tipo_entrega' },
        { label: 'Factura', id: 'factura' },
        { label: 'Creada por', id: 'usuario' },
      ], [
        { id: 'full_cancel', icon: 'clear', tooltip: 'Cancelar sin restricciones', access: [ACCESS.GUIA.CANCELAR_SIN_RESTRICCIONES] },
        { id: 'cancel', icon: 'cancel', access: [ACCESS.GUIA.CANCELAR_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIA.CANCELAR_GUIAS_DE_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.CANCELAR_TODAS_GUIAS]  },
        { id: 'edit', icon: 'edit', access: [ACCESS.GUIA.EDITAR_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIA.EDITAR_GUIAS_SUCURSAL_DEL_USUARIO, ACCESS.GUIA.EDITAR_TODAS_GUIAS] },
        { id: 'historial', icon: 'history', access: [ACCESS.GUIA.VER_HISTORIAL] },
        /* { id: 'comment', icon: 'comment', tooltip: 'Comentarios' }, */
      ]))
    this.table();
  }

  action = async (id, row) => {
    if (id === 'cancel') {
      this.setState({ dRow: row, dOpen: true, cancelType: 1 })
    } else if (id === 'historial') {
      this.setState({ dRow: row, dlOpen: true })
    } else if (id === 'edit') {
			this.props.history.push(`${this.config.modUrl}/${row.id}`)
		} else if (id === 'full_cancel') {
      this.setState({ dRow: row, dOpen: true, cancelType: 2 })
    } else if (id === 'comment') {
      this.setState({ dRow: row, dhOpen: true })
    }
  }

  cancel = async (op) => {
    const { cancelType } = this.state;
    if (op) {
      try {
        let url_cancel = '';
        if (cancelType === 1) {
          url_cancel = `guia/${this.state.dRow.id}/cancelar`;
        } else {
          url_cancel = `guia/${this.state.dRow.id}/cancelar-all`;
        }
        let Res = await Http.post(`${url_cancel}`, {});
        if (!Res.error) {
          this.table();
          this.setState({ dOpen: false, sbOpen: true, sbMsg: 'Guía cancelada exitosamente' })
        } else {
          const msg = Res.errMsg || Res.message || (typeof Res === 'string' ? Res : 'No se pudo cancelar la guía');
          this.setState({ dOpen: false, sbOpen: true, sbMsg: msg })
        }
      } catch (error) {
        this.setState({ dOpen: false, sbOpen: true, sbMsg: error?.message || 'Error al procesar la cancelación de la guía' })
      }
      return;
    }
    this.setState({ dOpen: false });
  }

  setOpenSg = (openSG)  => {
    this.setState({openSG})
  }

  setSearchOptions = (searchOptions)  => {
    this.setState({searchOptions})
  }

  preguiaSelectChange = async (value) => {
    this.props.history.push(`/Guias/Guia/${value.id_guia}`);
    this.setOpenSg(false)
  }

  valueSearchChange = async (value) => {
    const Res = await Http.post(`search/guia-all`, { search: value });
    if (!Res.error) {
      const guias  = Res.data;
      this.setSearchOptions(guias);
    }
  }

  render() {
    const { dOpen, dRow, dlOpen, sbOpen, sbMsg, openSG = false, searchOptions = [], dhOpen = false } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <div style={{ display: 'flex', padding: '0px 10px', justifyContent: 'space-between', alignItems: 'center' }} >
          <h1>Guías</h1>
            <Button 
              color="primary" 
              variant={"contained"} 
              endIcon={<Icon>search</Icon>}
              onClick={() => { this.setOpenSg(!openSG) }}>
              Buscar Guia
            </Button>
          { hasAccess([ACCESS.GUIA.CREAR_GUIAS, ACCESS.GUIA.CREAR_GUIAS_CLIENTE_USUARIO]) &&
            <Button color="primary" variant={"contained"} onClick={() => { this.props.history.push(`/Guias/Guia`) }} >
              Nueva Guia
            </Button>
          }
        </div>
        <this.TableRender />


        {/** Modal de cancelar guia */}
        <Dialog
          open={dOpen ? dOpen : false}
          onClose={() => this.setState({ dOpen: false })}
        >
          <DialogTitle>Confirmar cancelación</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Se va a cancelar la guía #{dRow ? dRow.g_folio : ''}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.cancel(false)} color="primary">
              No
            </Button>
            <Button onClick={() => this.cancel(true)} color="primary" autoFocus>
              Sí
            </Button>
          </DialogActions>
        </Dialog>

        {/** Modal de comentatios de la guia */}
        <Dialog
          maxWidth='md'
          open={dhOpen}
          onClose={() => this.setState({ dhOpen: false })}
        >
          <DialogTitle onClose={() => { this.setOpenSg(false) }}>
            Guia {dRow ? dRow.g_folio : ''}
          </DialogTitle>
          <DialogContent>
            <GuiaComment id={dRow ? dRow.id : ''} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ dhOpen: false })} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/** Modal de historial de guia */}
        <Dialog
          maxWidth='md'
          open={dlOpen ? dlOpen : false}
          onClose={() => this.setState({ dlOpen: false })}
        >
          <DialogContent>
            <GuiaLog id={dRow ? dRow.id : ''} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ dlOpen: false })} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/** Modal de buscar guias */}
        <Dialog onClose={() => { this.setOpenSg(false) }} open={openSG}>
          <DialogTitle onClose={() => { this.setOpenSg(false) }}>
            Buscar Guia
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <Autocomplete
                options={searchOptions}
                disableClearable
                getOptionLabel={option => option.Label}
                onChange={(e, val) => { this.preguiaSelectChange(val) }}
                renderInput={params => (
                  <TextField
                    style={{ minWidth: '400px' }}
                    {...params}
                    label='Buscar guia'
                    variant="outlined"
                    onChange={(e) => { this.valueSearchChange(e.target.value) }}
                    margin="normal"
                  />
                )}
              />
            </div>
          </DialogContent>
        </Dialog>

        <div>
          <Snackbar
            open={sbOpen}
            autoHideDuration={6000}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
        </div>

      </div>
    )
  }
}

export default withRouter(Guias)